import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import ProgressDots from "../components/ProgressDots";
import PrimaryButton from "../components/PrimaryButton";
import { t, tNode } from "../services/i18n";
import { track } from "../services/analytics";

interface Mode { name: string; description: string; }
const waves = ["\u223F", "\u223F\u223F", "\u223F\u223F\u223F"];
const waveColors = ["var(--color-primary)", "var(--color-accent-green)", "#7d4ce0"];

/** Informational only. No active selector - the mode is chosen on the
 *  physical device (spec section 4). */
export default function ModesPage() {
  const navigate = useNavigate();
  const modes = tNode<Mode[]>("modes.items", []);
  useEffect(() => {
    window.scrollTo(0, 0);
    track("modes_viewed");
  }, []);

  return (
    <>
      <AppHeader title={t("modes.title")} backTo="/hand-position" />
      <div className="page">
        <ProgressDots total={4} current={2} />
        <h2 className="h1">{t("modes.heading")}</h2>
        <p className="sub">{t("modes.subtitle")}</p>
        <div className="mt-24">
          {modes.map((m, i) => (
            <div className="card mode-card" key={m.name}>
              <span className="mode-card__wave" style={{ color: waveColors[i] }} aria-hidden="true">
                {waves[i]}
              </span>
              <span className="mode-card__name">{m.name}</span>
              <span className="mode-card__desc">{m.description}</span>
            </div>
          ))}
        </div>
        <div className="info-banner">{t("modes.sessionNote")}</div>
        <div className="mt-auto mt-24">
          <PrimaryButton label={t("common.continue")} onClick={() => navigate("/session")} />
        </div>
      </div>
    </>
  );
}
